__turbopack_context__.v({
  "actions": "E3XIOq_actions",
  "container": "E3XIOq_container",
  "description": "E3XIOq_description",
  "title": "E3XIOq_title",
});
